import React from 'react'
import { css } from '@emotion/core'

const h1Css = css`
  font-size: 80px;
  font-weight: 700;
  line-height: 80px;
`
const h2Css = css`
  font-size: 64px;
  font-weight: 700;
  line-height: 70px;
`
const h3Css = css`
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
`
const h4Css = css`
  font-size: 36px;
  font-weight: 400;
  line-height: 46px;
`
const h5Css = css`
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
`
const h6Css = css`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export function H1({ children, as: Type = 'h1' }) {
  return <Type css={h1Css}>{children}</Type>
}

export function H2({ children, as: Type = 'h2' }) {
  return <Type css={h2Css}>{children}</Type>
}

export function H3({ children, as: Type = 'h3' }) {
  return <Type css={h3Css}>{children}</Type>
}

export function H4({ children, as: Type = 'h4' }) {
  return <Type css={h4Css}>{children}</Type>
}

export function H5({ children, as: Type = 'h5' }) {
  return <Type css={h5Css}>{children}</Type>
}

export function H6({ children, as: Type = 'h6' }) {
  return <Type css={h6Css}>{children}</Type>
}
